/**
 * 健康习惯版本可用性（P0-0.1，§6「默认值来源」行）
 *
 * POST /healthHabit/version → { available, defaultVersion, reason }
 * 由 workwx 读 Apollo 下发；端点随 P1-1.5 落地。按 D13（内部管理台一刀切）这里既没有
 * grayPercent 也没有 whitelist：可用性是一个布尔，不做按人放量，服务端算、前端只消费。
 *
 * 与 P3 的教训相反：这里绝不把"服务故障"和"没开新版"塌成同一个 null。
 * 失败时返回 { ok:false, reason }，由调用方决定降级表现。
 *
 * 端点在后端上线前不存在（404 / 非 00000），此时外壳按 V1 渲染且不给切换入口 —— 这正是
 * "上线即默认旧版"的期望行为，所以不配 showError 弹窗，不打扰运营。
 * 另外 V2 还没打进 bundle 时外壳根本不发这个请求（见 index.jsx 的 v2Bundled 门控）。
 */
import $x from '@/utils/$x';

export async function getHealthHabitVersion(params) {
  try {
    const res = await $x.post('/healthHabit/version', params);
    if (!res || typeof res !== 'object') {
      return { ok: false, reason: 'MALFORMED_RESPONSE' };
    }
    // 响应信封：{ code, msg, data }；$x 已把 axios 的 res.data 剥了一层
    if (res.code !== undefined && String(res.code) !== '00000') {
      return { ok: false, reason: 'UPSTREAM_ERROR', code: String(res.code) };
    }
    const payload = res.data !== undefined ? res.data : res;
    if (!payload || typeof payload !== 'object') {
      return { ok: false, reason: 'MALFORMED_RESPONSE' };
    }
    return { ok: true, data: payload };
  } catch (error) {
    return { ok: false, reason: 'NETWORK_ERROR' };
  }
}
